import React from 'react';
import styles from './toggleTabs.module.scss';
import cx from 'classnames';
import { Typography } from '@primitives';
import { ITabsOption } from '../interfaces';
import { FontType } from '@primitives/Typography/types';
interface ToggleTabsProps {
  selected: string | boolean;
  onTabClick: (val: string | boolean) => void;
  tabOptions: ITabsOption[];
  size?: FontType;
  containerClass?: string;
  activeTabClass?: string;
  tabClass?: string;
  isToggleDisabled?: boolean;
}

const ToggleTabs: React.FC<ToggleTabsProps> = props => {
  const {
    selected,
    onTabClick,
    tabOptions,
    size,
    containerClass,
    activeTabClass,
    tabClass,
    isToggleDisabled = false
  } = props;

  return (
    <div className={cx(styles.container, containerClass)}>
      <div className={cx(styles.feedbackTabsWrapper, tabClass)}>
        {tabOptions.map((item, index) => (
          <div
            key={index}
            onClick={() => onTabClick(item.value)}
            className={cx(styles.tabItem, {
              [styles.active]: selected === item.value,
              [`${activeTabClass}`]: selected === item.value
            })}
            style={{ cursor: isToggleDisabled ? 'not-allowed' : 'pointer' }}
          >
            <Typography variant={size ? size : 'h4'}>{item.label}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToggleTabs;
